import { Flex, Skeleton, Typography } from 'antd'

export const FormSkeleton = () => {
  const { Text } = Typography
  const { Input, Button } = Skeleton
  return (
    <Flex vertical gap={30}>
      <div>
        <Text style={{ fontSize: 16 }}>Name *</Text>
        <Input
          block
          active
          style={{ height: 30, width: '30%', marginTop: 8 }}
        />
      </div>
      <div>
        <Text style={{ fontSize: 16 }}>Link *</Text>
        <Input
          block
          active
          style={{ height: 30, width: '30%', marginTop: 8 }}
        />
      </div>
      <Button block active style={{ height: 30, width: 60, marginTop: 24 }} />
    </Flex>
  )
}
